var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6268 21.8746C34.3768 28.1246 29.6643 34.0096 23.0518 35.3246C19.8268 35.9669 16.4813 35.5753 13.4918 34.2056C10.5023 32.8359 8.02108 30.558 6.40152 27.6961C4.78195 24.8342 4.10658 21.5343 4.47156 18.2663C4.83654 14.9983 6.22326 11.9287 8.43428 9.49463C12.9693 4.49963 20.6268 3.12463 26.8768 5.62463",
    stroke: "url(#paint0_linear_155_9315)",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 19.375L20.625 25.625L35.625 9.375",
    stroke: "url(#paint1_linear_155_9315)",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_9315",
    x1: 20.0009,
    y1: 4.40625,
    x2: 20.0009,
    y2: 35.6256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_155_9315",
    x1: 25,
    y1: 9.375,
    x2: 25,
    y2: 25.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledCheckIcon);
export default __webpack_public_path__ + "static/media/circled-check-icon.e112e726f39bfd94a18a801a2181e420.svg";
export { ForwardRef as ReactComponent };